import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Renderiza o alerta "seu plano vai expirar". O subject e o proprio
 * destinatario (User); o nome do plano e os dias restantes vem de content()
 * (data) para montar o texto e o excerpt.
 */
export default class PlanExpiringNotification extends Notification {
  icon() {
    return 'fas fa-clock';
  }
  href() {
    return app.route('marketplace.subscriptions');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.plan_expiring', {
      plan: data.plan_name,
      days: data.days
    });
  }
  excerpt() {
    return this.attrs.notification.content()?.plan_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/PlanExpiringNotification', PlanExpiringNotification);